export default __webpack_public_path__ + "static/media/whatsMoves.6836da95.svg";